/**
 * Browser print-to-PDF is the demo's PDF export, so the print rules live with
 * the report rather than in a global stylesheet: everything outside the report
 * card is hidden, and the card loses the screen chrome that wastes a page.
 */
export const BILLING_REPORT_PRINT_CLASS = "epocus-billing-report";

export const BILLING_REPORT_PRINT_CSS = `
@media print {
  body * { visibility: hidden; }
  .${BILLING_REPORT_PRINT_CLASS}, .${BILLING_REPORT_PRINT_CLASS} * {
    visibility: visible;
  }
  .${BILLING_REPORT_PRINT_CLASS} {
    position: absolute;
    inset: 0;
    margin: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    max-width: none;
  }
  @page { margin: 14mm; }
}
`;
